import { Page, type PageProperties } from '../objects/Page'
import { Provider } from '../objects/Provider'
import { Country } from '../objects/Country'
import { Corridor } from '../objects/Corridor'
import { CurrencyPair } from '../objects/CurrencyPair'
import { View } from '../actions'
import { analytics } from './lib'

export const ErrorView = <
  T extends { message: string; statusCode: number; statusMessage?: string },
>(
  error: T,
) =>
  analytics(
    new View(),
    new Page('Error', {
      pageCategory: 'error',
      techError: {
        message: error.message,
        statusCode: error.statusCode,
        statusMessage: error.statusMessage,
      },
    }),
  )

export const PageView = (pageName: string, properties?: PageProperties) =>
  analytics(new View(), new Page(pageName, { pageCategory: 'generic', ...properties }))

export const AppPageView = (pageName: string, properties?: PageProperties) =>
  analytics(new View(), new Page(pageName, { pageCategory: 'app', ...properties }))

export const HomeView = (properties?: PageProperties) =>
  analytics(new View(), new Page('Home', { pageCategory: 'home', ...properties }))

export const LandingView = (properties?: PageProperties) =>
  analytics(new View(), new Page('Landing', { pageCategory: 'landing', ...properties }))

export const CountryView = (country: Country, properties?: PageProperties) =>
  analytics(
    new View(),
    new Page('Country', {
      pageCategory: 'country',
      countryPage: country.properties,
      ...properties,
    }),
  )

export const CurrencyView = (currencyPair: CurrencyPair, properties?: PageProperties) =>
  analytics(
    new View(),
    new Page('BestExchangRate', {
      pageCategory: 'currencies',
      ...currencyPair.properties,
      ...properties,
    }),
  )

export const ReviewView = (provider: Provider, properties?: PageProperties) =>
  analytics(
    new View(),
    new Page('Review', {
      pageCategory: 'review',
      ...provider.properties,
      ...properties,
    }),
  )

export const MoneyTransferView = (corridor: Corridor, properties?: PageProperties) =>
  analytics(
    new View(),
    new Page('IMT Results', {
      pageCategory: 'moneyTransfer',
      ...corridor.properties,
      ...properties,
    }),
  )
